import { render } from "./TimelineComponent.vue?vue&type=template&id=5bb95dc6&scoped=true"
import script from "./TimelineComponent.vue?vue&type=script&lang=js"
export * from "./TimelineComponent.vue?vue&type=script&lang=js"

import "./TimelineComponent.vue?vue&type=style&index=0&id=5bb95dc6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb95dc6"]])

export default __exports__